export class ErrorForDisplay {
  userErrorId: string;
  userMessages: string[] = [];
}
